import * as TK from 'components/BusinessGifting/translations/constant';
import { eventInfoDialogCommonLocale } from 'components/BusinessGifting/ContactDialog/translations/common.locale';

export const businessGiftingCommonLocale = {
  [TK.DEFAULT_TITLE]: 'Business Gifting',
  ...eventInfoDialogCommonLocale,
};
